// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"5b34c94b","798":"6d466070","851":"c900b8c8"}[chunkId] + ".chunk.css";
};